define('sentient/aba/models/PrimeModel',[
	'underscore',
	'backbone',
	'loglevel'
	], function(_, Backbone, log) {
		var PrimeModel = Backbone.Model.extend({
			defaults: {
				'original-width': NaN,
				'original-height': NaN,
				'original-aspect-ratio': NaN,
				'start-scale': 0.7,
				'end-scale': 0.9,
				'time': 500,
				'max-dimension': NaN
			},
			initialize: function(attributes) {

				var model = this;
				model.set('ready', false);
				if (attributes.type == 'image') {
					model.image = document.createElement('img');
					model.image.setAttribute('src', attributes.source);

					model.image.addEventListener('load', function() {
						var image = this;
						model.image.setAttribute('date-original-width', image.width);
						model.image.setAttribute('date-original-height', image.height);
						model.image.setAttribute('date-original-aspect-ratio', (image.width / image.height));
						model.set({
							'original-width': image.width,
							'original-height': image.height,
							'original-aspect-ratio': (image.width / image.height),
							'ready': true
						});
					});
          //IE 9 wont load content from https unless it is in the DOM.
          document.getElementById('img-loading-area').appendChild(model.image);
				} else if (attributes.type == 'text') {
					var image = model.image = document.createElement('canvas');
					model.image.setAttribute('width', 1900);
					model.image.setAttribute('height', 1900 / 2);
					var context = model.image.getContext('2d');
					context.fillStyle = '#FFFFFF'; // set canvas background color
					context.fillRect(0, 0, image.width, image.height);  // now fill the canvas
					var fontFamily = $('.sentient-aba-session-frame').css('fontFamily');

					var fontHeight = 10;
					var widthMaxed = false;
					var fontWidth = 0;
					while (!widthMaxed) {
						context.font = (fontHeight * 1.1).toString() + 'px ' + fontFamily;
						fontWidth = context.measureText(attributes.source);

						if (fontWidth.width < image.width) {
							fontHeight = fontHeight * 1.1;
						} else {
							widthMaxed = true;
						}
					}
					context.font = (fontHeight).toString() + 'px ' + fontFamily;
					fontWidth = context.measureText(attributes.source);
					//log.debug("context.font :", context.font);
					//log.debug("fontWidth :", fontWidth);
					context.textAlign = 'center';
					context.fillStyle = 'black';
					context.fillText(attributes.source, image.width / 2, (image.height / 2) + fontHeight / 3);
					model.set({
						'original-width': image.width,
						'original-height': image.height,
						'original-aspect-ratio': (image.width / image.height),
						'ready': true
					});

				}
			},
			calculateDimensions: function(drawAreaWidth, drawAreaHeight) {
				drawAreaWidth = drawAreaWidth;
				drawAreaHeight = drawAreaHeight;
				//If we are not in the ready state when calculateDimensions() is called, wait for ready and then call it again.
				if (!this.get('ready')) {
					this.listenToOnce(this, 'change:ready', $.proxy(function(model, value, options) {
						model.calculateDimensions(this.drawAreaWidth, this.drawAreaHeight);
					},{'drawAreaWidth': drawAreaWidth, 'drawAreaHeight': drawAreaHeight}));
					return;
				}
				//The screen can have a larger width OR height. We need to use the smaller
				//of the too to figuer out the primes large ans small sizes.

				var maxDimension = Math.min(drawAreaWidth, drawAreaHeight);

				var startBoxDimension = maxDimension * this.get('start-scale');
				var startBoxWidth = Math.min(startBoxDimension, startBoxDimension * this.get('original-aspect-ratio'));
				var startBoxHeight = Math.min(startBoxDimension, startBoxDimension / this.get('original-aspect-ratio'));
				var startBoxOffset = (maxDimension / 2) - (startBoxDimension / 2);
				var startBoxOffsetX = (maxDimension / 2) - (startBoxWidth / 2);
				var startBoxOffsetY = (maxDimension / 2) - (startBoxHeight / 2);
				var endBoxDimension = maxDimension * this.get('end-scale');
				var endBoxWidth = Math.min(endBoxDimension, endBoxDimension * this.get('original-aspect-ratio'));
				var endBoxHeight = Math.min(endBoxDimension, endBoxDimension / this.get('original-aspect-ratio'));
				var endBoxOffset = (maxDimension / 2) - (endBoxDimension / 2);
				var endBoxOffsetX = (maxDimension / 2) - (endBoxWidth / 2);
				var endBoxOffsetY = (maxDimension / 2) - (endBoxHeight / 2);
					//log.debug({'drawAreaWidth':drawAreaWidth,'drawAreaHeight':drawAreaHeight});
					//log.debug({'maxDimension':maxDimension});
					//log.debug({'startBoxDimension':startBoxDimension,'startBoxOffset':startBoxOffset,'endBoxDimension':endBoxDimension,'endBoxOffset':endBoxOffset});

					this.set({
						'max-dimension': maxDimension,
						'start-width': startBoxWidth,
						'start-height': startBoxHeight,
						'start-offset-x': startBoxOffsetX,
						'start-offset-y': startBoxOffsetY,
						'end-width': endBoxWidth,
						'end-height': endBoxHeight,
						'end-offset-x': endBoxOffsetX,
						'end-offset-y': endBoxOffsetY
					});
			}

		});
		return PrimeModel;
	});

